import axios from '@/api/config';
const campus = {
  getCampusTree(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampusTree`, {
      params: data
    });
  },
  getCampusInfo(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampusInfo`, {
      params: data
    });
  },
  getClassStartPeriod(data) {
    return axios.get(`${process.env.BASE_URL}/schedulePeriod/getSchedulePeriodList`, {
      params: data
    });
  },
  updateClassRemark(data) {
    return axios.post(`${process.env.BASE_URL}/classInfoPhase/addRemark`, data);
  },
  getPermissionCampusTree(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampusTreeByPermission`, {
      params: data
    });
  },
  getPermissionSubjectTree(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectCourseTreeByPermission`, {
      params: data
    });
  },
  getDepartmentTree(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getDepartmentTree`, {
      params: data
    });
  },
  getCampusList(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampusList`, data)
  },
  addCampus(data) {
    return axios.post(`${process.env.BASE_URL}/campus/addCampus`, data)
  },
  getCampus(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampus`, {
      params: data
    })
  },
  getHomeworkFinishingRate(data) {
    return axios.post(`${process.env.BASE_URL}/scheduleInfo/getHomeworkFinishingRate`, data)
  },
  exportScheduleInfo(data) {
    return axios.post(`${process.env.BASE_URL}/scheduleInfo/exportExcel`, data)
  },
  exportHomeworkAccuracy(data) {
    return axios.post(`${process.env.BASE_URL}/signInLog/exportExcelNew`, data)
  },
  updateCampus(data) {
    return axios.put(`${process.env.BASE_URL}/campus/updateCampus`, data)
  },
  deleteCampus(data) {
    return axios.delete(`${process.env.BASE_URL}/campus/deleteCampus`, {
      data: data
    })
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/campus/pageList`, data)
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/campus/active`, data)
  },
  // 机构后台查询本机构下的教材分页列表
  pageListByAgent(data) {
    return axios.post(`${process.env.BASE_URL}/textBookItemAgent/pageListByAgent`, data);
  },
  // 查询教材报名的学员
  textBookStudentApplyList(data) {
    return axios.post(`${process.env.BASE_URL}/textBookStudentApply/pageList`, data);
  },
  //签到概况
  signInGeneral(data) {
    return axios.post(`${process.env.BASE_URL}/signInLog/signReCordList`, data);
  },
  //做题概况
  generalSituation(data) {
    return axios.post(`${process.env.BASE_URL}/signInLog/signReCordList`, data);
  },
}
export default campus



// WEBPACK FOOTER //
// ./src/api/campus.js